import apiClient from "../apiClient";
import { COMMON_ENDPOINTS } from "../endpoints/common";
import { CART_ENDPOINTS } from "../endpoints/cart";
import { normalizeCartApiPayload } from "@/utils/bookingHelpers";

export const createCart = async (payload) => {
  try {
    const response = await apiClient.post(
      COMMON_ENDPOINTS.createCart,
      normalizeCartApiPayload(payload)
    );
    return response.data;
  } catch (error) {
    console.error("Error creating cart:", error);
    throw error;
  }
};

export const createTempBooking = async (payload) => {
  try {
    const response = await apiClient.post(
      CART_ENDPOINTS.createTempBooking,
      normalizeCartApiPayload(payload)
    );
    return response.data;
  } catch (error) {
    console.error("Error creating temp booking:", error);
    throw error;
  }
};

export const getTempBooking = async (payload) => {
  try {
    const res = await apiClient.post(
      CART_ENDPOINTS.getTempBooking,
      {},
      { params: payload }
    );
    return res.data;
  } catch (error) {
    console.error(
      "GetTempBooking error:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const GetTempBooking = getTempBooking;
